import { useEventListener } from 'ahooks';

/**
 * @description https://ahooks.js.org/hooks/use-event-listener
 */
export default useEventListener;
